module.exports = __webpack_public_path__ + "static/media/chess.a023c20d.jpg";